export class InactiveIngredientFilterSettingsModel {
  public inactiveIngredienName: string;
  public alphaIndex: string;
}